import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Subject, switchMap } from 'rxjs';

@Injectable()
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translocoService = inject(TranslocoService);
  private readonly titleResource = new Subject<string>();

  constructor() {
    super();
    this.titleResource
      .pipe(switchMap((titleKey) => this.translocoService.selectTranslate<string>(titleKey)))
      .subscribe((title) => this.title.setTitle(title));
  }

  override updateTitle(routerStateSnapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(routerStateSnapshot);
    if (title !== undefined) {
      this.titleResource.next(title);
    }
  }
}
